export function mustFindBy<T, TKey>(items: readonly T[], keyFn: (obj: T) => TKey, key: TKey, name: string): T {
    const item = items.find((i) => keyFn(i) === key);
    if (!item) {
        throw new Error(`Cannot find ${name} with ${keyFn.name ?? "key"}=${JSON.stringify(key)}`);
    }
    return item;
}
